import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home/Home";
import About from "./pages/Home/About/About";
import Skills from "./pages/Home/Skills/Skills";
import Contact from "./pages/Home/Contact/Contact";
import Projects from "./pages/Home/Projects/Projects";
import ProjectDetails from "./pages/Home/ProjectDetails/ProjectDetails";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skill" element={<Skills />} />
        <Route path="/project" element={<Projects />} />
        <Route path="/details/:_id" element={<ProjectDetails />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
